import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormDateField from 'modules/ui/editform/fields/EditFormDateField';
import EditFormDateTimeField from 'modules/ui/editform/fields/EditFormDateTimeField';
import VizsgaEditService from '../service/VizsgaEditService';
import PaperTypeDto from '../dto/PaperTypeDto';

const booleanList = [
	{
		id: true,
		name: 'Igen'
	},
	{
		id: false,
		name: 'Nem'
	}
];

const config = {
	key: 'vizsgaEditForm',
	text: 'Vizsga',
	textKey: 'vizsga',
	service: VizsgaEditService,
	fields: [
		{
			key: 'tesztlapMegnezhetoIn',
			text: 'Tesztlap megnézhető',
			textKey: 'tesztlapMegnezhetoIn',
			component: EditFormSelectField,
			required: true,
			items: booleanList
		},
		{
			key: 'leiras',
			text: 'Leírás',
			textKey: 'leiras',
			component: EditFormTextField,
			required: true
		},
		{
			key: 'nyitolap',
			text: 'Nyitólap a csomaghoz',
			component: EditFormSelectField,
			type: 'enum',
			items: Object.keys(PaperTypeDto).map(d => {
				return { value: d, label: PaperTypeDto[d] };
			})
		},
		{
			key: 'datum',
			text: 'Dátum',
			textKey: 'datum',
			component: EditFormDateField,
			required: true
		},
		{
			key: 'vizsgaKezdesDatum',
			text: 'Vizsga kezdése',
			textKey: 'vizsgaKezdesDatum',
			component: EditFormDateTimeField,
			required: true
		},
		{
			key: 'vizsgaKezdesVarakozas',
			text: 'Lehetőség a belépésre a vizsga kezdetétől (perc)',
			textKey: 'vizsgaKezdesVarakozas',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'vizsgaIdo',
			text: 'Vizsga ideje percben',
			textKey: 'vizsgaIdo',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'kKarId',
			text: 'Kar',
			textKey: 'kKarId',
			component: EditFormSelectField,
			items: () => VizsgaEditService.getKarSelection()
		},
		{
			key: 'nyomtatvaIn',
			text: 'Nyomtatva',
			textKey: 'nyomtatvaIn',
			component: EditFormSelectField,
			required: true,
			items: booleanList
		},
		{
			key: 'lezarvaIn',
			text: 'Lezárva',
			textKey: 'lezarvaIn',
			component: EditFormSelectField,
			required: true,
			items: booleanList
		},
		{
			key: 'reklamacioLezarasDatum',
			text: 'Reklamáció lezárásának ideje',
			textKey: 'reklamacioLezarasDatum',
			component: EditFormDateTimeField,
			required: true
		},
		{
			key: 'kettes',
			text: 'Kettes',
			textKey: 'kettes',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'harmas',
			text: 'Hármas',
			textKey: 'harmas',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'negyes',
			text: 'Négyes',
			textKey: 'negyes',
			component: EditFormTextField,
			type: 'number',
			required: true
		},
		{
			key: 'otos',
			text: 'Ötös',
			textKey: 'otos',
			component: EditFormTextField,
			type: 'number',
			required: true
		}
	]
};

function VizsgaEditForm() {
	return <EditFormPage config={config} />;
}

export default VizsgaEditForm;
